import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
} from "react-router-dom";
import { ErrorPage } from "./pages/ErrorPage";
import { ProtectedLayout } from "./pages/ProtectedLayout";
import { createRoot } from "react-dom/client";
import React from "react";
import "./index.css";
import HomePage from "./pages/HomePage";
import { AuthLayout } from "./pages/AuthLayout";
import { LoginPage } from "./pages/LoginPage";
import { CellInfo } from "./components/CellInfo";
import { SignupPage } from "./pages/SignupPage";
import { PhysicalTwinning } from "./components/PhysicalTwinning";
import { CellStore } from "./components/CellStore";
import { AddCell } from "./components/AddCell";
import { BatteryScope } from "./pages/BatteryScope/BatteryScope";
import { AuthProvider } from "./contexts/auth";
import { ToastProvider } from "./components/Toast/Toast";
import { GoogleOAuthProvider } from "@react-oauth/google";
import {UserInventory} from "./pages/UserInventory/UserInventory";
import {ViewCellCategory} from "./pages/CellScope/ViewCellCategory/ViewCellCategory";
import BatteryScopeV2 from "./pages/BatteryScopeV2/BatteryScopeV2";
import BatteryScopeV2C from "./pages/BatteryScopeV2-C/BatteryScopeV2C";
import { BatteryConfigProvider } from './pages/BatteryScopeV2/context/BatteryConfigContext';
import BatteryScopeC from "./pages/BatteryScopeC/BatteryScopeC";
import CellHealthCertificatePage from "./pages/CellHealthCertificatePage";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<AuthLayout />}>
        <Route index element={<LoginPage />} />
        <Route path="signup" element={<SignupPage />} />
      </Route>
      <Route path="*" element={<ErrorPage />} />
      <Route path="/auth" element={<ProtectedLayout />}>
      <Route index element={<Navigate to="physioscope" />} />
        <Route path="physioscope" element={<PhysicalTwinning />} />
        <Route path="cellscope/all" element={<CellStore />} />
        <Route path="addCell" element={<AddCell mode="add" />}>
          <Route path={":cellId"} element={<AddCell mode={"edit"} />} />
        </Route>
        <Route path={"cellStore/:cellId"} element={<CellInfo />} />
        <Route path={"cellscope"} element={<ViewCellCategory />} />
        <Route path="inventory" element={<UserInventory />} />
        {/* <Route path="battery-scope" element={<BatteryScope />} /> */}
      </Route>
        <Route path="batteryscope/*" element={<BatteryScopeV2 />} />
        <Route path="batteryscope-c/*" element={<BatteryScopeV2C />} />
        <Route path="cell-health-certificate" element={<CellHealthCertificatePage />} />
    </>,
  ),
);

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <BatteryConfigProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
        </BatteryConfigProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);
